import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { Blurhash } from "react-blurhash";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Box } from "@aksara-ui/react";

interface Props {
  src?: string | undefined;
  blurHash?: any;
  alt?: string | undefined;
  height?: string | number | undefined;
  width?: string | number | undefined;
  style?: React.CSSProperties | undefined;
}

const LazyLoadImageWithBlurHash: React.FC<Props> = ({
  src,
  blurHash,
  alt,
  height,
  width,
  style,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Box
    //   style={{
    //     position: "relative",
    //     width: width || "100%",
    //     height: height || "100%",
    //   }}
    >
      {
        !imageLoaded
        //   && (
        //     <Blurhash
        //       hash={blurHash}
        //       width="100%"
        //       height="100%"
        //       resolutionX={32}
        //       resolutionY={32}
        //       punch={1}
        //       style={{
        //         position: "absolute",
        //         top: 0,
        //         left: 0,
        //         width: "100%",
        //         height: "100%",
        //       }}
        //     />
        //   )
      }
      <LazyLoadImage
        src={src}
        alt={alt}
        effect="blur"
        onLoad={() => setImageLoaded(true)}
        height={height}
        width={width}
        style={style}
      />
    </Box>
  );
};

export default LazyLoadImageWithBlurHash;
